import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface SuccessStepProps {
  successMessage?: ReactNode;
}

export const SuccessStep = ({ successMessage }: SuccessStepProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          {t('csvImport.steps.success.title', 'Import Successful')}
        </Typography>
        {successMessage && typeof successMessage !== 'string' ? (
          successMessage
        ) : (
          <Typography variant="body1" color="text.secondary">
            {successMessage ??
              t(
                'csvImport.steps.success.defaultMessage',
                'Your CSV file has been successfully imported.',
              )}
          </Typography>
        )}
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {t(
            'csvImport.steps.success.nextSteps',
            'You can now view and manage your imported data.',
          )}
        </Typography>
      </Box>
    </Box>
  );
};
